'use client';

import { http } from 'viem';
import { arbitrum, base, mainnet, optimism, polygon, sepolia } from 'viem/chains';
import { createConfig } from 'wagmi';

// Configure supported chains
export const supportedChains = [mainnet, polygon, optimism, arbitrum, base, sepolia] as const;

// Create wagmi config
export const wagmiConfig = createConfig({
  chains: [mainnet, polygon, optimism, arbitrum, base, sepolia],
  transports: {
    [mainnet.id]: http(),
    [polygon.id]: http(),
    [optimism.id]: http(),
    [arbitrum.id]: http(),
    [base.id]: http(),
    [sepolia.id]: http(),
  },
  ssr: true, // Enable server-side rendering support
});
